import {
  FEATURE_TIPS,
  getFeatureTipsSorted,
  type FeatureTip,
} from './featureTipsCatalog';

const DISMISSED_TIPS_KEY = 'falcon-planner:feature-tips-dismissed';

/** Dispatched when a tip is dismissed so header badge stays in sync. */
export const FEATURE_TIPS_CHANGED_EVENT = 'falcon-planner:feature-tips-changed';

function readDismissedIds(): string[] {
  if (typeof window === 'undefined') return [];
  try {
    const raw = localStorage.getItem(DISMISSED_TIPS_KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw) as unknown;
    if (!Array.isArray(parsed)) return [];
    return parsed.filter((id): id is string => typeof id === 'string');
  } catch {
    return [];
  }
}

function writeDismissedIds(ids: string[]): void {
  if (typeof window === 'undefined') return;
  localStorage.setItem(DISMISSED_TIPS_KEY, JSON.stringify(ids));
  window.dispatchEvent(
    new CustomEvent(FEATURE_TIPS_CHANGED_EVENT, { detail: { dismissedIds: ids } }),
  );
}

export function getDismissedFeatureTipIds(): string[] {
  return readDismissedIds();
}

export function isFeatureTipDismissed(id: string): boolean {
  return readDismissedIds().includes(id);
}

export function dismissFeatureTip(id: string): void {
  const current = readDismissedIds();
  if (current.includes(id)) return;
  writeDismissedIds([...current, id]);
}

export function getUndismissedFeatureTips(): FeatureTip[] {
  const dismissed = new Set(readDismissedIds());
  return getFeatureTipsSorted().filter((tip) => !dismissed.has(tip.id));
}

export function getUndismissedFeatureTipCount(): number {
  return getUndismissedFeatureTips().length;
}

/** All catalog tips (for Tips hub list), regardless of dismiss state. */
export function getAllFeatureTips(): FeatureTip[] {
  return getFeatureTipsSorted();
}

export function hasFeatureTips(): boolean {
  return FEATURE_TIPS.length > 0;
}
